import { ReciboClientePago } from './recibo-cliente';
import { Business } from './user';

export class ComprobanteDetalle {
  id?: number | null;
  comprobanteId?: number | null;
  empresaId?: number;
  numeroSerie?: string;
  numeroInicio?: number | null;
  estado?: string;
  comprobante?: Comprobante;
  empresa?: Business;

  [key: string]: any;

  constructor(object?: any) {
    if (object) {
      for (const key of Object.keys(object)) {
        this[key] = object[key];
      }
      if (object.comprobante) {
        this.comprobante = new Comprobante(object.comprobante);
      }
      /*if (object.reciboClientePago) {
        this.reciboClientePago = object.reciboClientePago.map(data => new ReciboClientePago(data));
      }*/
    } else {
      this.initializeValues();
    }
  }

  initializeValues(): void {
    this.id = null;
    this.comprobanteId = null;
    this.numeroSerie = '';
    this.numeroInicio = null;
    this.estado = '';
  }
}

export class Comprobante {
  id?: number | null;
  nombre?: string;
  comprobanteDetalle?: ComprobanteDetalle[];

  [key: string]: any;

  constructor(object?: any) {
    if (object) {
      for (const key of Object.keys(object)) {
        this[key] = object[key];
      }
      if (object.comprobanteDetalle) {
        this.comprobanteDetalle = object.comprobanteDetalle.map((data: any) => new ComprobanteDetalle(data));
      }
    } else {
      this.initializeValues();
    }
  }

  initializeValues(): void {
    this.id = null;
    this.nombre = '';
  }
}
